import React from 'react';
import { SearchInput, useInputHelper } from 'framework/form';
import { ProcessAssetsType } from 'domain/gpo/processAssets/types';
import { PROCESS_ASSETS_CTO, PROCESS_ASSETS_SUPPORTS } from 'domain/gpo/processAssets/constants';
import { useAuthorization } from 'framework/authorization';
import { ListParams, useListContext } from 'framework/list';

type ProcessAssetNameSuggestionInputProps = {
  source: string;
  label: string;
  placeholder: string;
  disabled: boolean;
};

// Only for list
const ProcessAssetNameSuggestionInput = ({ source, ...props }: ProcessAssetNameSuggestionInputProps) => {
  const { getRawOnChangeCallback } = useInputHelper({ source });
  const { data } = useListContext();
  const { isGranted } = useAuthorization();

  const { items } = data || ({ items: [] } as { items: ProcessAssetsType[] });

  const onChangeCallback = getRawOnChangeCallback();
  const onInputChangeCallback = (resultValue: string) => {
    onChangeCallback?.({ [source]: resultValue });
  };

  const selectSuggestionMethod = (resultValue: StringOrNumber) => {
    const element = items!.find(
      (item: ProcessAssetsType) => item.metadata.templateName.toLowerCase() === String(resultValue).toLowerCase(),
    ) as ProcessAssetsType;
    onChangeCallback?.({
      owner: element.metadata.owner,
      section: element.metadata.section,
      fileType: element.metadata.fileType,
      office: element.metadata.office,
    });
  };

  const loadSuggestions = (query: ListParams) => {
    const {
      searchString: { ct: searchString = '' },
    } = query.filter || { searchString: { ct: '' } };

    const rez = items!.filter(item => item.metadata.templateName.toLowerCase().includes(searchString.toLowerCase()));

    return {
      result: rez,
      totalPages: 1,
    };
  };

  const mapResults = (item: ProcessAssetsType) => {
    return {
      id: item.metadata.templateName,
      text: item.metadata.templateName,
    };
  };

  // Access to upload only new versions of your own templates
  const accessUpalodNewTemplates = isGranted([PROCESS_ASSETS_CTO, PROCESS_ASSETS_SUPPORTS]);

  return (
    <SearchInput
      selectSuggestionMethod={selectSuggestionMethod}
      onInputChangeCallback={accessUpalodNewTemplates ? onInputChangeCallback : undefined}
      searchRequest={loadSuggestions}
      mapResults={mapResults}
      source={source}
      nameSource={source}
      {...props}
    />
  );
};

export default ProcessAssetNameSuggestionInput;
